import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { detectUserLanguage, getLanguageFromPath, addLanguageToPath } from '../../lib/utils/geolocation';

export function LanguageRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const handleLanguageRedirect = async () => {
      const currentLang = getLanguageFromPath(location.pathname);
      
      if (currentLang) {
        // URL'de Türkçe dil kodu varsa, i18n'i güncelle
        if (i18n.language !== currentLang) {
          await i18n.changeLanguage(currentLang);
        }
      } else {
        // URL'de dil kodu yoksa (ana domain), otomatik tespit et
        const detectedLang = await detectUserLanguage();
        
        if (detectedLang === 'tr') {
          // Türk kullanıcıyı /tr'ye yönlendir
          const newPath = addLanguageToPath(location.pathname, detectedLang);
          await i18n.changeLanguage(detectedLang);
          navigate(newPath, { replace: true });
        } else {
          // İngilizce kullanıcı ana domainde kalır
          if (i18n.language !== 'en') {
            await i18n.changeLanguage('en');
          }
        }
      }
    };

    handleLanguageRedirect();
  }, [location.pathname, navigate, i18n]);

  return null; // Bu component görsel bir şey render etmez
}